<template>
  <footer class="footer">
    <!--
    <newsletter-modal :modal="modal"></newsletter-modal>
    <a href="https://itunes.apple.com/gb/app/fonetti/id1332609392?mt=8" target="_blank"><img src="../assets/img/app-store-white.svg" alt="Download on the App Store" class="footer__app-store"></a>
    <p>Available for iPad only</p>
    <v-button class="newsletter-button" @click="modal.show('newsletter')">Register your interest in other platforms</v-button>
    -->
    <div class="appstore-badges">
      <a href="https://app.fonetti.com" target="_blank"><img src="../assets/img/webapp-button.svg" alt="Read on Fonetti" /></a>
    </div>
    <img src="../assets/img/logo-footer.png" alt="empowered by Auris" class="footer__logo fit-img">
  </footer>
</template>

<script>
import ModalJS from '@/components/classes/Modal';
// import Button from '@/components/utils/Button';
// import NewsletterModal from '@/components/NewsletterModal';

export default {
  name: 'v-footer',
  components: {
    // 'v-button': Button,
    // NewsletterModal,
  },
  data() {
    return {
      modal: new ModalJS({
        newsletter: false,
      }),
    };
  },
};
</script>

<style lang="scss" scoped>
  .appstore-badges {
    a {
      width: 100%;
      display:block;
      margin: 1em 0;
      img {
        width:100%;
        filter: drop-shadow(0px 0px 3px rgba(0,0,0,0.3));
      }
    }
  }
</style>
